import Axios from "axios";

var aiBaseURL = (process.env.VUE_APP_API_URL || "https://api.arboran.com.br/api/")
  .replace(/\/api\/$/, "/ai-service/api/v1");
if (process.env.NODE_ENV === "development") {
  aiBaseURL = "http://localhost:8000/api/v1";
}

const aiHttp = Axios.create({
  baseURL: aiBaseURL
});

const local = JSON.parse(localStorage.getItem("user-token"));
if (local) {
  aiHttp.defaults.headers.common["Authorization"] = "bearer " + local.token;
}

aiHttp.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error && error.response && error.response.status === 401) {
      localStorage.removeItem("user-token");
      window.location.reload();
    }
    return Promise.reject(error);
  }
);

class PmauService {
  GetStages() {
    return aiHttp({
      url: "/stages",
      method: "GET"
    });
  }

  UploadContentImage(contaId, file) {
    var formData = new FormData();
    formData.append("file", file);
    return aiHttp({
      url: "/content-images/" + contaId,
      data: formData,
      method: "POST",
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  }

  GenerateStage(contaId, stageCode, request) {
    return aiHttp({
      url: "/generate",
      data: Object.assign({}, request || {}, { conta_id: contaId, stage_code: stageCode }),
      method: "POST"
    });
  }

  GetContent(contaId, stageCode) {
    return aiHttp({
      url: "/content/" + contaId + "/" + stageCode,
      method: "GET"
    });
  }

  SaveContent(contaId, stageCode, content, selectedOptions) {
    var data = { content: content };
    if (selectedOptions !== undefined) data.selected_options = selectedOptions;
    return aiHttp({
      url: "/content/" + contaId + "/" + stageCode,
      data: data,
      method: "PUT"
    });
  }

  ExportChapter(contaId, chapterCode) {
    return aiHttp({
      url: "/export/" + contaId + "/" + chapterCode,
      method: "GET",
      responseType: "blob"
    });
  }

  GetExportStatus(contaId) {
    return aiHttp({
      url: "/export/" + contaId + "/status",
      method: "GET"
    });
  }

  ExportFull(contaId) {
    return aiHttp({
      url: "/export/" + contaId + "/full",
      method: "GET",
      responseType: "blob"
    });
  }

  // ── Dados GAAU para gráficos renderizados no cliente (Highcharts) ───────

  GetDendrometricStats(contaId) {
    return aiHttp({
      url: "/gaau/dendrometric/" + contaId,
      method: "GET"
    });
  }

  GetSpeciesStats(contaId) {
    return aiHttp({
      url: "/gaau/species/" + contaId,
      method: "GET"
    });
  }

  GetOriginStats(contaId) {
    return aiHttp({
      url: "/gaau/origin/" + contaId,
      method: "GET"
    });
  }

  GetGaauIndexStats(contaId) {
    return aiHttp({
      url: "/gaau/gaau-index/" + contaId,
      method: "GET"
    });
  }

  // ── Admin — CRUD de Variáveis PMAU ──────────────────────────────────────

  ListVariables(includeInactive = false) {
    return aiHttp({
      url: "/admin/pmau-variables",
      method: "GET",
      params: includeInactive ? { include_inactive: true } : {}
    });
  }

  CreateVariable(data) {
    return aiHttp({
      url: "/admin/pmau-variables",
      data,
      method: "POST"
    });
  }

  UpdateVariable(id, data) {
    return aiHttp({
      url: "/admin/pmau-variables/" + id,
      data,
      method: "PUT"
    });
  }

  DeleteVariable(id) {
    return aiHttp({
      url: "/admin/pmau-variables/" + id,
      method: "DELETE"
    });
  }

  // ── Por conta — Valores de variáveis ────────────────────────────────────

  GetVariableValues(contaId) {
    return aiHttp({
      url: "/pmau-variables/" + contaId,
      method: "GET"
    });
  }

  SaveVariableValues(contaId, values) {
    return aiHttp({
      url: "/pmau-variables/" + contaId,
      data: values,
      method: "PUT"
    });
  }

  UploadVariableImage(contaId, variableId, file) {
    var formData = new FormData();
    formData.append("file", file);
    return aiHttp({
      url: "/pmau-variables/" + contaId + "/" + variableId + "/image",
      data: formData,
      method: "POST",
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  }

  // ── Admin — CRUD de Prompts ──────────────────────────────────────────────

  ListPrompts(stageCode = null) {
    const params = stageCode ? { stage_code: stageCode } : {};
    return aiHttp({
      url: "/admin/prompts",
      method: "GET",
      params
    });
  }

  GetPrompt(stageCode, promptType) {
    return aiHttp({
      url: "/admin/prompts/" + stageCode + "/" + promptType,
      method: "GET"
    });
  }

  UpdatePrompt(stageCode, promptType, data) {
    return aiHttp({
      url: "/admin/prompts/" + stageCode + "/" + promptType,
      data,
      method: "PUT"
    });
  }
}

export default new PmauService();
